import axios from 'axios'
import { message } from './resetMessage.js'
import {
  ElMessageBox 
} from 'element-plus'
import { getCookie } from './cache'
import store from '../store'
import i18n from '@/lang'
import qs from 'qs'
class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    }
    return config
  }

  // 设定拦截器
  interceptors(instance) {
    instance.interceptors.request.use((config) => {
      const tenantId = getCookie(import.meta.env.VITE_VUETENANT_STR)
      const token = getCookie(import.meta.env.VITE_VUETOKEN_STR)
      const langr = getCookie(import.meta.env.VITE_VUELANG_STR)
      if (config.method === 'get') {
        // get请求方式下，把数组转成同名参数
        config.paramsSerializer = function (params) {
          return qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }
      }
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token // 携带权限参数
        config.headers['User-Type'] = '01'
      }
      if (langr) {
        config.headers['Langr'] = langr // 携带多语言参数
      }
      if (tenantId) {
        config.headers['tenantId'] = tenantId // 携带租户id
      }
      return config
    }, (error) => {
      return Promise.reject(error)
    })
    instance.interceptors.response.use(response => {
      const {
        data
      } = response
      if (data.code === 200) {
        return Promise.resolve(data)
      } else if (response.config.responseType === 'blob') {
        if (response.data.type.includes('application/json')) {
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
              const content = reader.result
              const fileRes = JSON.parse(content)
              message.error(i18n.global.t(fileRes.msg))
              reject(fileRes)
            }
            reader.readAsText(response.data)
          })
        } else {
          return Promise.resolve(response)
        }
      } else {
        if (data.code === 403) {
          ElMessageBox .alert(data.msg ? data.msg : '', i18n.global.t('提示'), {
            confirmButtonText: i18n.global.t('确定'),
            type: 'warning',
            callback: action => {
              store.dispatch('LogInit', {},).then(() => {
                location.reload()
              })
            }
          })
        }
        if (!response.config.silentError && data.msg) {
          message.error(data.msg)
        }
        return Promise.reject(response)
      }
    }, error => {
      const response = error.response
      if (response?.status === 401 && response.config.url !== '/auth/oauth/token') {
        ElMessageBox .alert(response.data && response.data.msg ? response.data.msg : '', i18n.global.t('提示'), {
          confirmButtonText: i18n.global.t('确定'),
          type: 'warning',
          callback: action => {
            store.dispatch('LogInit', {},).then(() => {
              location.reload()
            })
          }
        })
      } else if (!error.config?.silentError) {
        message.error(response?.data?.msg ? response.data.msg : i18n.global.t('连接失败'))
      }
      return Promise.reject(error)
    })
  }

  // 创建实例
  request(optios) {
    const instance = axios.create()
    const _options = Object.assign(this.getInsideConfig(), optios)
    this.interceptors(instance)
    return instance.request(_options)
  }

  get(url, params, config) {
    const options = Object.assign({
      method: 'get',
      url: url,
      params: params
    }, config)
    return this.request(options)
  }
  post(url, params, config) {
    const options = Object.assign({
      method: 'post',
      url: url,
      data: params
    }, config)
    return this.request(options)
  }

  put(url, data) {
    return this.request({
      method: 'put',
      url,
      data
    })
  }

  delete(url, data, config) {
    return this.request({
      method: 'delete',
      url,
      data,
      ...config
    })
  }
}

export default HttpRequest
